




























































































































import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// Models
import { Paginator } from '@/models'
import { Piecework, FilterPiecework } from '@/models/piecework'
import { HeadquarterModel, AreaModel } from '@/models/config'

// services
import { PieceworkService } from '@/services/piecework'
import { HeadquarterService, AreaService } from '@/services/config'

// components
import { PageHeader } from '@/components'
import { DatePicker, Select2 } from '@/components/general'
import { DataTable } from '@/components/table'

// utils
import moment from 'moment'
import { alerts, loading, getFullNameFormat } from '@/utils'

// hooks
import { useEmployees } from '@/hooks'

export default defineComponent({
  name: 'PieceworkIndex',
  components: {
    PageHeader,
    DataTable,
    DatePicker,
    Select2
  },
  setup (props, { root: { $store } }) {
    const isLoading = ref(false)
    const loadingHeadquarter = ref(false)
    const loadingArea = ref(false)
    const title = ref('Destajo Grupal')
    const breadcrumbs = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Destajo Grupal',
        active: true
      }
    ]

    const headers = [
      {
        key: 'date',
        label: 'Fecha',
        sortable: true,
        formatter: (value: string) => moment(value).format('DD/MM/YYYY'),
        class: 'text-center'
      },
      {
        key: 'headquarter.name',
        label: 'Sede',
        sortable: true,
        class: 'text-center'
      },
      {
        key: 'area.name',
        label: 'Área',
        sortable: true,
        class: 'text-center'
      },
      {
        key: 'is_wage',
        label: 'Jornal',
        sortable: true,
        formatter: (value: boolean) => value ? 'SI' : 'NO',
        class: 'text-center'
      },
      {
        key: 'actions',
        label: ''
      }
    ]

    const items: Ref<Piecework[]> = ref([])

    const pagination: Ref<Paginator> = ref({
      currentPage: 1,
      total: 0,
      count: 0,
      perPage: 10
    })

    const filters: Ref<FilterPiecework> = ref({
      ...$store.getters['piecework/filters']
    })

    const { employees, getEmployees, loadingEmployees } = useEmployees()
    getEmployees()
    const employeesOp = computed(() => {
      return employees.value
        .filter(employee =>
          !filters.value.headquarter ? true : Number(employee.assignment.headquarter_id) === Number(filters.value.headquarter)
        )
        .filter(employee =>
          !filters.value.area ? true : Number(employee.assignment.area_id) === Number(filters.value.area)
        )
        .filter(employee => employee.is_active)
        .map(employee => {
          return {
            value: employee.id,
            text: getFullNameFormat(employee)
          }
        })
    })

    const headquarters: Ref<HeadquarterModel[]> = ref([])
    const getHeadquarters = async () => {
      loadingHeadquarter.value = true
      headquarters.value = await HeadquarterService.getAllActivate()
      loadingHeadquarter.value = false
    }
    getHeadquarters()

    const headquartersOp = computed(() => {
      return headquarters.value.map(head => {
        return {
          value: head.id,
          text: head.name
        }
      })
    })

    const areas: Ref<AreaModel[]> = ref([])
    const getAreas = async () => {
      loadingArea.value = true
      areas.value = await AreaService.getAllActivate()
      loadingArea.value = false
    }
    getAreas()

    const areasOp = computed(() => {
      return areas.value.map(area => {
        return {
          value: area.id,
          text: area.name
        }
      })
    })

    const getPieceworks = async () => {
      isLoading.value = true
      const response = await PieceworkService.getAllWithPagination(pagination.value.perPage, pagination.value.currentPage, filters.value)
      $store.dispatch('piecework/changeFilters', filters.value)
      items.value = response.objects
      pagination.value = {
        ...response.pagination
      }
      isLoading.value = false
    }
    getPieceworks()

    const changePage = (page: number) => {
      pagination.value.currentPage = page
      getPieceworks()
    }

    const changePerPage = (perPage: number) => {
      pagination.value.perPage = perPage
      pagination.value.currentPage = 1
      getPieceworks()
    }

    const deleteItem = async (item: Piecework) => {
      const msg = 'Seguro que desea eliminar el elemento seleccionado'
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await PieceworkService.delete(item.id)
        alerts.success()
        getPieceworks()
        loading('hide')
      }
    }

    const clearFilters = () => {
      $store.dispatch('piecework/clearFilters')
      filters.value = {
        ...$store.getters['piecework/filters']
      }
    }

    return {
      title,
      breadcrumbs,
      isLoading,
      headers,
      items,
      pagination,
      changePage,
      changePerPage,
      deleteItem,
      filters,
      getPieceworks,
      headquartersOp,
      areasOp,
      clearFilters,
      loadingHeadquarter,
      loadingArea,
      employeesOp,
      loadingEmployees
    }
  }
})
